export default "__VITE_ASSET__C2rnDl8W__"